import { render, staticRenderFns } from "./clientDetail.vue?vue&type=template&id=1cadd69c"
import script from "./clientDetail.vue?vue&type=script&lang=js"
export * from "./clientDetail.vue?vue&type=script&lang=js"
import style0 from "./clientDetail.vue?vue&type=style&index=0&id=1cadd69c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports